var exports = {
  "iE": "x234b8571--3bd1bb--wrapper",
  "DD": "x234b8571--3bd1bb--title",
  "sP": "x234b8571--3bd1bb--source",
  "vt": "x234b8571--3bd1bb--description-icon",
  "aw": "x234b8571--3bd1bb--slider",
  "x$": "x234b8571--3bd1bb--slider-list",
  "L2": "x234b8571--3bd1bb--source-link",
};

module.exports = exports;
